import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import request from 'lib/request';
import type { QueueSummary } from './types';

// Refresh trigger atom - increment to refetch summary
const refreshCounterAtom = atom(0);

// Base async atom for O(1) queue summary (size + latency)
const summaryBaseAtom = atom(async (get) => {
  get(refreshCounterAtom);
  const response = await request.get<QueueSummary>(
    '/admin/intersection_coordination_queue'
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});

const summaryLoadableAtom = loadable(summaryBaseAtom);

export const queueSummaryAtom = atom(
  (get) => get(summaryLoadableAtom),
  (_get, set) => {
    set(refreshCounterAtom, (c) => c + 1);
  }
);
